import EMPLOYMENT_TYPES from '../constants/employment-types';
const EMPLOYMENT_TYPE_VALUES = EMPLOYMENT_TYPES.map(et => et.value);
export default (({
  message = 'Invalid employment type.'
} = {}) => value => EMPLOYMENT_TYPE_VALUES.includes(value) ? null : message);